var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("main", [
    _c("p", [_vm._v("Contact page")]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "align-items": "center",
          height: "100%",
          width: "100%",
        },
      },
      [
        _c(
          "yandex-map",
          {
            staticStyle: { width: "100%", height: "600px" },
            attrs: { coords: [53.903017, 27.56078], zoom: "16" },
          },
          [
            _c("ymap-marker", {
              attrs: {
                "marker-type": "placemark",
                "marker-id": "1",
                coords: [53.903017, 27.56078],
                "hint-content": "Магазин Umberto Imperial",
                balloon: {
                  header: "Umberto Imperial",
                  body: "Магазин Umberto Imperial, лучшие шмотки в минске",
                  footer: "тел.: +375 29 123 12 12",
                },
                icon: { color: "green", glyph: "shopping" },
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }